import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useKenoAccess } from 'hooks/useKenoAccess';
import styles from './KenoHome.module.css';

// Keno colours: 1-20 green, 21-40 blue, 41-60 orange, 61-80 yellow.
const colorOf = (n: number) =>
  ['#5fb648', '#3d95e6', '#ee7a2c', '#f2cc43'][Math.floor((n - 1) / 20)];
// A strip of the board; the drawn ones light up in turn.
const BOARD = [4, 11, 18, 23, 29, 41, 47, 62, 74];
const LIT = [18, 47, 62, 29, 74, 4];

/** Modern home: the way into Keno (unless switched off for the player). */
export const KenoHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const enabled = useKenoAccess();
  if (!enabled) return null;
  return (
    <>
      <div className={styles.head}>
        <h2>{t('keno_label')}</h2>
      </div>
      <button
        type="button"
        className={styles.card}
        onClick={() => navigate('/keno')}
      >
        <span className={styles.title}>
          KENO <em>20/80</em>
        </span>
        <span className={styles.sub}>{t('keno_home_sub')}</span>
        <span className={styles.board} aria-hidden>
          {BOARD.map((n) => {
            const lit = LIT.indexOf(n);
            return (
              <i
                key={n}
                className={lit >= 0 ? styles.lit : undefined}
                style={
                  {
                    '--c': colorOf(n),
                    animationDelay: lit >= 0 ? `${lit * 0.6}s` : undefined,
                  } as React.CSSProperties
                }
              >
                {n}
              </i>
            );
          })}
          <b className={styles.mult}>×2</b>
        </span>
        <span className={styles.play}>{t('lucky_six_play')}</span>
      </button>
    </>
  );
};
